<div class="text-center" style="display: flex; justify-content: center; align-items: center; padding: 15%">
  <div class="fg-red text-bold text-upper" style="top: 50%;">
    <p style="font-size: 3rem">-404-</p>
    <p>¡Página no encontrada!</p>
  </div>
</div>
